export default "__VITE_ASSET__DLevGhUA__"